import { FC, useCallback } from 'react'
import { Navigate, useParams } from 'react-router'
import Button, { ButtonStyle } from 'src/components/01_atoms/Button/Button'
import Header from 'src/components/02_molecules/Header/Header'
import Hero from 'src/components/02_molecules/Hero/Hero'
import Page from 'src/components/03_organisms/Page/Page'
import RoutePath from 'src/structures/Enums/RoutePath.enum'
import { isNotEmpty, isNotNullOrUndefined } from 'src/utils/guards.utils'

type IMenuScannerUploadProperties = Record<string, null>

const MenuScannerUpload: FC<IMenuScannerUploadProperties> = () => {
    const { sessionId } = useParams()

    const handleAddImage = useCallback(() => {
        console.log('Add image')
    }, [])

    if (isNotNullOrUndefined(sessionId) && isNotEmpty(sessionId)) {
        return (
            <Page
                header={
                    <Header
                        backButton={RoutePath.MENU_SCANNER_LOCATION}
                        title='Scanner'
                    />
                }
                footer={
                    <div className='h-28'>
                        <div className='fixed flex items-center justify-center bottom-0 left-0 right-0 p-6'>
                            <Button
                                disabled
                                className='w-full max-w-screen-lg'
                                buttonStyle={ButtonStyle.PRIMARY}
                                onClick={handleAddImage}>
                                Add image
                            </Button>
                        </div>
                    </div>
                }>
                <Hero>
                    <h1 className='h3 text-center'>Add images</h1>
                </Hero>
            </Page>
        )
    }

    return (
        <Navigate
            to={RoutePath.ROOT}
            replace
        />
    )
}

export default MenuScannerUpload
